enum AccountPixTypeEnum {
  'phoneNumber' = 'Telefone',
  'nationalRegistration' = 'CPF',
  'email' = 'Email',
  'evp' = 'Chave aleatória',
}

enum SecurityAnalysisTexts {
  'CNH' = 'CNH',
  'ENDERECO' = 'ENDEREÇO',
  'SELFIE' = 'SELFIE',
  'CPF' = 'CPF',
  'APROVADO' = 'aprovado',
  'NÃO APROVADO' = 'nao-aprovado',
  'EM ANÁLISE' = 'em-analise',
  'NÃO INFORMADO' = 'nao-informado',
}

enum SecurityAnalysisColors {
  'APROVADO' = 'green',
  'NÃO APROVADO' = 'red',
  'EM ANÁLISE' = 'orange',
  'NÃO INFORMADO' = 'default',
}

export { AccountPixTypeEnum, SecurityAnalysisColors, SecurityAnalysisTexts };
